import axios from "axios"
import  Urls from "./Urls";
import LocalStorage from "../tools/LocalStorage";

const Api = axios.create({
    baseURL:Urls.root,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        "Device-Id" :LocalStorage.getDeviceId(),

    },
},);
Api.interceptors.response.use(function (response) {
        console.log(response)
        return response;

}, function (error) {

    return {
        hasError:true,
        data:null,
        status:error.response.status,
        message:error.response.message,
    }

});

export default Api;
